module.exports = __webpack_public_path__ + "img/puerto-rico.bb8bafe1.png";